import React, { FC, memo } from 'react'
import Icon from '@ucheba/ui/icons/icon__arrow-right.svg'
import styled, { StyledProps } from 'styled-components'
import { sv } from '@ucheba/utils/helpers/styles/variables'
import { IBreadcrumbListProps } from '../types'

const Block = styled.div<StyledProps<any>>`
  color: ${(props) => sv.color[props.color]};
  font-size: 12px;
`

const IconWrap = styled.span`
  display: inline-flex;
  width: 12px;
  position: relative;
  height: 100%;
  margin: 0 4px;
`

const BreadcrumbList: FC<IBreadcrumbListProps> = (props) => {
  const { list, justifyContent = 'flex-start', color = 'coffee60' } = props

  return (
    <Block color={color}>
      <ul
        itemScope
        itemType='https://schema.org/BreadcrumbList'
        style={{
          display: 'flex',
          padding: 0,
          margin: 0,
          flexWrap: 'wrap',
          justifyContent,
        }}
      >
        {list.map((item, key) => {
          if (key === 0) {
            return (
              <li
                key={key}
                itemProp='itemListElement'
                itemScope
                itemType='https://schema.org/ListItem'
              >
                <a
                  itemProp='item'
                  href={item.href}
                  style={{
                    display: 'inline-flex',
                    color: 'inherit',
                  }}
                >
                  <span itemProp='name'>{item.name}</span>

                  {list.length - 1 !== key && (
                    <IconWrap>
                      <Icon
                        width='12px'
                        style={{
                          position: 'absolute',
                        }}
                      />
                    </IconWrap>
                  )}
                </a>

                <meta itemProp='position' content={`${key + 1}`} />
              </li>
            )
          }

          return (
            <li
              key={key}
              itemProp='itemListElement'
              itemScope
              itemType='https://schema.org/ListItem'
            >
              <a
                itemScope
                itemType='https://schema.org/WebPage'
                itemProp='item'
                itemID={item.href}
                href={item.href}
                style={{
                  display: 'inline-flex',
                  color: 'inherit',
                }}
              >
                <span itemProp='name'>{item.name}</span>

                {list.length - 1 !== key && (
                  <IconWrap>
                    <Icon
                      width='12px'
                      style={{
                        position: 'absolute',
                      }}
                    />
                  </IconWrap>
                )}
              </a>

              <meta itemProp='position' content={`${key + 1}`} />
            </li>
          )
        })}
      </ul>
    </Block>
  )
}

export default memo(BreadcrumbList)
